import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/sti-reverse-scan/scan-empty-state.svg'
import _imports_2 from '@/app/ui/assets/svg/out_hub_logo.svg'
import _imports_3 from '@/app/ui/assets/svg/stt-not-valid.svg'
import _imports_4 from '@/app/ui/assets/svg/out-hub-logo-partially.svg'
import _imports_5 from '@/app/ui/assets/svg/noData_filter.svg'
import _imports_6 from '@/app/ui/assets/svg/no-data-list.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-21522f86")

_pushScopeId("data-v-21522f86")
const _hoisted_1 = { class: "px-8 py-4 flex flex-row gap-4 items-center border-b border-gray-lp-1400 bg-white" }
const _hoisted_2 = { class: "text-black-lp-200 font-semibold text-xl" }
const _hoisted_3 = { class: "bg-gray-lp-1000 px-3 py-2.5 h-full flex flex-col gap-y-3" }
const _hoisted_4 = { class: "bg-white flex flex-col text-xs h-full relative w-full px-3 py-2 rounded-lg" }
const _hoisted_5 = {
  class: "relative w-full flex items-center",
  style: {"min-height":"211px"}
}
const _hoisted_6 = { class: "absolute top-1 right-0" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col gap-3 justify-center items-center w-full"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "empty-state"
}, null, -1)
const _hoisted_9 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col justify-center items-center gap-2 w-full"
}
const _hoisted_11 = {
  key: 2,
  class: "flex flex-col gap-3 justify-center items-center w-full"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "in-hub"
}, null, -1)
const _hoisted_13 = {
  key: 3,
  class: "flex flex-col gap-3 justify-center items-center w-full"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: "stt-not-valid"
}, null, -1)
const _hoisted_15 = {
  key: 4,
  class: "flex flex-col gap-3 justify-center items-center w-full pb-6"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  alt: "in-hub-logo-partially"
}, null, -1)
const _hoisted_17 = { class: "text-sm text-gray-lp-300 py-1 px-2 bg-yellow-lp-400 rounded-lg shadow" }
const _hoisted_18 = { class: "input-scan w-full" }
const _hoisted_19 = { class: "flex flex-row justify-between items-center w-full py-4" }
const _hoisted_20 = { class: "flex flex-row gap-2.5 items-center justify-start" }
const _hoisted_21 = {
  key: 0,
  class: "flex flex-row rounded-lg gap-x-4"
}
const _hoisted_22 = { class: "flex flex-row" }
const _hoisted_23 = { class: "text-14px font-normal text-gray-lp-800" }
const _hoisted_24 = {
  class: "ml-4 text-14px font-semibold text-black-lp-100",
  "data-testid": "hub-to-hub-update-header-stt-koli"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"1px","background":"#D4D5D8"},
  class: "h-auto"
}, null, -1)
const _hoisted_26 = { class: "flex flex-row" }
const _hoisted_27 = { class: "text-14px font-normal text-gray-lp-800" }
const _hoisted_28 = {
  class: "ml-4 text-14px font-semibold text-black-lp-100",
  "data-testid": "hub-to-hub-update-header-gross-weight"
}
const _hoisted_29 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_30 = { class: "w-full h-screen pb-32 overflow-auto" }
const _hoisted_31 = {
  key: 1,
  class: "flex justify-center w-full h-full flex-col items-center"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  alt: "not-data-filter",
  width: "160",
  height: "135"
}, null, -1)
const _hoisted_33 = { class: "text-sm text-gray-lp-800" }
const _hoisted_34 = {
  key: 1,
  src: _imports_6,
  alt: "not-data-list",
  width: "160",
  height: "135"
}
const _hoisted_35 = { class: "text-sm text-gray-lp-800" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ScanFailedCard = _resolveComponent("ScanFailedCard")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_Search = _resolveComponent("Search")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ModalManifest = _resolveComponent("ModalManifest")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("button", null, [
        _createVNode("img", {
          class: "w-6 h-6",
          src: _imports_0,
          alt: "back",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        })
      ]),
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('hubToHub.updateOutHub')), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_Transition, { name: "notification" }, {
              default: _withId(() => [
                (_ctx.InHubScanFailedList.length)
                  ? (_openBlock(), _createBlock(_component_ScanFailedCard, {
                      key: 0,
                      data: _ctx.InHubScanFailedList
                    }, null, 8, ["data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          (
            !_ctx.temporaryList.length &&
              !_ctx.loadingIllustration &&
              !_ctx.illustrationData.isInvalid &&
              !_ctx.controller.isLoadingTemporaryList &&
              !_ctx.illustrationData.isPartially
          )
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('hubToHub.scanEmptyCta')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.controller.isLoadingTemporaryList || _ctx.loadingIllustration)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_Skeleton, {
                  width: "283px",
                  height: "61px"
                }),
                _createVNode(_component_Skeleton, {
                  width: "264px",
                  height: "110px"
                }),
                _createVNode(_component_Skeleton, {
                  width: "205px",
                  height: "24px"
                })
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.temporaryList.length &&
              !_ctx.loadingIllustration &&
              !_ctx.illustrationData.isInvalid &&
              !_ctx.controller.isLoadingTemporaryList &&
              !_ctx.illustrationData.isPartially
          )
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _hoisted_12
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.illustrationData.isInvalid &&
              !_ctx.loadingIllustration &&
              !_ctx.controller.isLoadingTemporaryList &&
              !_ctx.illustrationData.isPartially
          )
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _hoisted_14
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.illustrationData.isPartially &&
              !_ctx.loadingIllustration &&
              !_ctx.controller.isLoadingTemporaryList
          )
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("p", _hoisted_17, [
                  _createVNode("b", null, _toDisplayString(_ctx.tempSttNo), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('hubToHub.partiallyUpdated')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_lp_input, {
            ref: "inputStt",
            "data-testid": "hub-to-hub-update-input-scan-stt",
            modelValue: _ctx.form.sttNumber,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.sttNumber = $event)),
            sizeInput: "24px",
            bold: !!_ctx.form.sttNumber,
            labelStacked: _ctx.$t('handover.update.sttNumber.label'),
            placeholder: _ctx.$t('handover.update.sttNumber.placeholder'),
            onEnter: _ctx.onScanSttNumber,
            onFocus: _ctx.onSetFocusRefs
          }, null, 8, ["modelValue", "bold", "labelStacked", "placeholder", "onEnter", "onFocus"])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode(_component_Search, {
              class: "w-full mr-0",
              style: {"margin-right":"0","width":"220px"},
              placeholder: _ctx.$t('hubToHub.searchBagSttPlaceholder'),
              value: _ctx.form.search,
              onInput: _ctx.onSearch,
              onClear: _ctx.onClearSearch
            }, null, 8, ["placeholder", "value", "onInput", "onClear"]),
            (_ctx.temporaryList.length)
              ? (_openBlock(), _createBlock("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('hubToHub.totalSttKoliLabel')), 1),
                    _createVNode("p", _hoisted_24, _toDisplayString(_ctx.formattedTotalStt) + "/" + _toDisplayString(_ctx.formattedTotalPieces), 1)
                  ]),
                  _hoisted_25,
                  _createVNode("div", _hoisted_26, [
                    _createVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('hubToHub.grossWeight')), 1),
                    _createVNode("p", _hoisted_28, _toDisplayString(_ctx.formattedGrossWeight), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode(_component_lp_button, {
              onClick: _ctx.onConfirmStiManifest,
              title: _ctx.$t('hubToHub.processManifest'),
              "text-color": "white",
              disabled: !_ctx.temporaryList.length
            }, null, 8, ["onClick", "title", "disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_30, [
          (_ctx.temporaryList.length)
            ? (_openBlock(), _createBlock(_component_TableV2, {
                key: 0,
                columns: _ctx.columns,
                data: _ctx.temporaryList,
                "pagination-style": "v3",
                isPinnedScrollBottom: "",
                pinnedSubstractHeight: "260px",
                loading: _ctx.controller.isLoadingTemporaryList,
                isBorderOnHeadBgWhite: "",
                customClassPagination: "absolute w-full bottom-16 z-30 pr-8",
                isNoPaddingBottom: "true",
                pagination: _ctx.pagination
              }, null, 8, ["columns", "data", "loading", "pagination"]))
            : _createCommentVNode("", true),
          (!_ctx.temporaryList.length)
            ? (_openBlock(), _createBlock("div", _hoisted_31, [
                (_ctx.form.search)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_32,
                      _createVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('hubToHub.bagSttNotFound')), 1)
                    ], 64))
                  : (_openBlock(), _createBlock("img", _hoisted_34)),
                _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('hubToHub.noPackagesScanned')), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_ModalManifest, {
        isOpen: _ctx.openModal,
        isStatus: 'OUT-HUB',
        "onUpdate:isOpen": _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal = $event))
      }, null, 8, ["isOpen"])
    ])
  ], 64))
})